import React from 'react';
import Pagination from "react-js-pagination";
import Helpers from "../Helpers/Custom";
import Config  from "../Helpers/Config";

function MyPagination(props) {

  
    let activePage = props.activePage;
    let totalItemsCount = props.totalRecords;
    let onChange = props.onChange;

    let itemsCountPerPage = props.itemsCountPerPage || Config.defaultPageSize;
    let pageRangeDisplayed= props.pageRangeDisplayed || Config.pageRangeDisplayed;
    let innerClass= props.innerClass || "div-pagination float-right";

   
    return (
        <Pagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    pageRangeDisplayed={pageRangeDisplayed}
                    onChange={onChange}
                    innerClass={innerClass}
                  />
    )
}

export default MyPagination
